import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Menu,
    MenuItem,
    IconButton,
    Button
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";

const languages = {
    tr: { label: 'TR', name: 'Türkçe', iso2: 'TR', dir: 'ltr' },
    fa: { label: 'FA', name: 'فارسی', iso2: 'IR', dir: 'rtl' },
    ar: { label: 'AR', name: 'العربية', iso2: 'SA', dir: 'rtl' },
};

const LanguageSwitcher = ({classes}) => {
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const currentLang = i18n.language in languages ? i18n.language : 'tr';

    const switchLanguage = (lang) => {
        //i18n.changeLanguage(lang);
        localStorage.setItem('language', lang);
        window.location.reload();
    };

    const renderFlag = (iso2) => (
        <img
            src={`https://flagsapi.com/${iso2}/flat/24.png`}
            alt="flag"
            className={classes.flagStyle}
            loading="lazy"
        />
    );

    return (
        <>
            <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                size="small"
                color="inherit"
                startIcon={renderFlag(languages[currentLang].iso2)}
            >
                {languages[currentLang].label}
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                {Object.keys(languages).map((lang) => (
                    <MenuItem
                        key={lang}
                        selected={lang === currentLang}
                        onClick={() => {
                            switchLanguage(lang);
                            setAnchorEl(null);
                        }}
                    >
                        {renderFlag(languages[lang].iso2)}
                        {languages[lang].name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
export default withStyles(Styles)(LanguageSwitcher);

